import {GameFlowController} from '../../components/game-flow-controller.js';
import {Localization} from '../../utils/Localization.js';
import {ConfirmationDialogController} from '../panels/confirmation-dialog.js';

export function goToMainMenuConfirmation() {
    const loc = Localization.instance;
    ConfirmationDialogController.instance.displayDialog(
        loc.get('LoseProgressDialog'),
        loc.get('LoseProgressDialogAccept'),
        loc.get('LoseProgressDialogReject'),
        (accepted) => {
            if (accepted) {
                GameFlowController.instance.goToMainMenu();
            }
        }
    );
}
